import React, { Component } from 'react'
import { Form, Field, FieldArray } from 'redux-form'
import { Container } from 'components/Layout'
import Button from 'components/Button'
import SelectPretty from 'components/Input/SelectPretty'
import { Textarea } from 'components/Input/Textarea'
import { vRequired } from 'components/Input/Input.validations'
import FieldArrayRows from 'components/Input/FieldArrayRows'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

const roleOptions = ['ROLE_API_USER', 'ROLE_API_ADMIN', 'ROLE_API_WHOLESALER'].map(item => ({
  value: item,
  name: item,
}))

const RolesComponent = props => (
  <Field
    label="Role"
    name="type"
    component={SelectPretty}
    options={roleOptions}
    validate={[vRequired]}
    {...props}
  />
)

export default class UsersSetRolesModal extends Component {
  onSubmit = formData => {
    const { setRoles, modalConfirm } = this.props
    return setRoles(formData).then(modalConfirm)
  }
  render() {
    const { modalCancel, submitting, handleSubmit } = this.props

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Change User Roles</div>
          <br />
          <Form onSubmit={handleSubmit(this.onSubmit)}>
            <FieldArray name="roles" FieldComponent={RolesComponent} component={FieldArrayRows} />
            <div
              className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
              style={{ marginTop: '40px' }}
            >
              <Button color="tertiary" type="submit" loading={submitting}>
                Submit
              </Button>
              <br />
              <br />
              <Button plain onClick={modalCancel}>
                Cancel
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/UsersSetRolesModal/UsersSetRolesModal.jsx